import { defineComponent as _defineComponent } from 'vue'
import { PropType, computed, useRouter, useStore } from "@nuxtjs/composition-api";

import { getLtksStore } from "@/store/ltks";
import { getProductDetailsStore } from "@/store/product-details";
import { getProductsStore } from "@/store/products";
import { getProfilesStore } from "@/store/profiles";


export default /*#__PURE__*/_defineComponent({
  __name: 'LtkItemProduct',
  props: {
  ltkId: { type: String, required: true },
  productIds: { type: Array<string>, required: true },
  referringComponent: { type: String, required: true },
  brand: { type: Object as PropType<BrandProfile>, default: null }, // used to filter products to a specific brand
  brandRetailerIds: { type: Array as PropType<string[]>, default: null }, // used to filter products to a specific brand
},
  setup(__props) {

const props = __props;



const store = useStore();
const router = useRouter();
const productStore = getProductsStore(store);
const productDetailsStore = getProductDetailsStore(store);
const profileStore = getProfilesStore(store);
const ltksStore = getLtksStore(store);
const profileId = computed(() => ltksStore.ltks[props.ltkId]?.profileId);
const profileDisplayName = computed(() => profileStore.profiles[profileId.value ?? ""]?.displayName || "");

const filteredProductIds = computed(() => {
  if (!props.brandRetailerIds || !props.brand) {
    return props.productIds;
  }

  return (
    props.productIds.filter((productId) => {
      const detailId = productStore.products[productId]?.productDetailsId;
      if (!detailId) {
        return false;
      }
      const ids = productDetailsStore.productDetails[detailId]?.retailerIds ?? [];
      return ids?.some((id) => props.brandRetailerIds.includes(id));
    }) ?? []
  );
});

const toCreatorPost = () => {
  router.push({
    name: "explore-displayName-posts-id",
    params: { displayName: profileDisplayName.value, id: props.ltkId },
  });
};

return { __sfc: true,props, store, router, productStore, productDetailsStore, profileStore, ltksStore, profileId, profileDisplayName, filteredProductIds, toCreatorPost }
}

})